import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Spinner, CheckCircle, DiscordLogo } from "@phosphor-icons/react";
import { API, setToken, setKind } from "@/lib/api";

export default function DiscordCallback() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("Verifying with Discord…");
  const [done, setDone] = useState(null); // {invite_url, username} for visitor success

  useEffect(() => {
    const code = params.get("code");
    const state = params.get("state") || "";
    if (!code) {
      setStatus("Missing code param.");
      return;
    }
    axios.post(`${API}/auth/discord/callback`, { code, state })
      .then((r) => {
        const data = r.data;
        if (data.kind === "creator") {
          setToken(data.access_token);
          setKind("creator");
          toast.success("Creator authenticated");
          nav("/creator");
          return;
        }
        // visitor: attribution locked; forward to the Discord invite
        if (data.redirect_url) {
          setDone({ invite_url: data.redirect_url, username: data.username });
          // brief pause so they see confirmation, then redirect
          setTimeout(() => window.location.replace(data.redirect_url), 1200);
        } else {
          setDone({ invite_url: null, username: data.username });
        }
      })
      .catch((err) => {
        let d = err?.response?.data?.detail;
        if (Array.isArray(d)) d = d.map((e) => e?.msg || "").join(", ");
        else if (typeof d !== "string") d = null;
        setStatus(d || "Callback failed");
        toast.error("Discord callback failed");
      });
  }, [params, nav]);

  if (done) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6">
        <div className="card-tactical p-8 max-w-md text-center">
          <CheckCircle size={40} weight="fill" color="#22C55E" className="mx-auto" />
          <div className="display-heading font-bold text-xl mt-3">Verified @{done.username}</div>
          {done.invite_url ? (
            <>
              <p className="text-white/60 mt-2 font-mono text-xs">Redirecting to Discord…</p>
              <a href={done.invite_url} className="neon-btn inline-flex items-center gap-2 mt-4 px-4 py-2">
                <DiscordLogo size={18} weight="fill" /> OPEN DISCORD MANUALLY
              </a>
            </>
          ) : (
            <p className="text-white/60 mt-2 font-mono text-xs">Attribution saved. Owner hasn't set an invite URL yet.</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="card-tactical p-8 max-w-md">
        <div className="flex items-center gap-3">
          <Spinner className="animate-spin" size={22} color="#00F0FF" />
          <span className="font-mono text-sm">{status}</span>
        </div>
      </div>
    </div>
  );
}
